import {
    BASE_URL,
    GET,
    IAM_RIGHTS,
    PAGE_SIZE
} from "../constants";
import { statusParsing, jsonParsing } from "../utils";
import { getAccessToken } from "../../authActions/authActions";

export const fetchUserData = async (type,custID,searchKey,next,userNames="",roles="",sort="",pageSize=PAGE_SIZE) => {
    const token = await getAccessToken();
   let resource=`${BASE_URL}${IAM_RIGHTS}`;  

 let array = [
    {
      key:"searchKey",
      value:encodeURIComponent(searchKey)
    },
    {
        key:"type",
        value:type
      },
    {
      key:"custID",
      value:encodeURIComponent(custID)
    },
    {
      key:"next",
      value:next
    },
    {
      key:"userNames",
      value:encodeURIComponent(userNames)
    },
    {
      key:"roles",
      value:encodeURIComponent(roles)
    },
    {
      key:"sort",
      value:encodeURIComponent(sort)
    },
    {
      key:"pageSize",
      value:encodeURIComponent(pageSize)
    }
  ]  

  let queryString=``;
  array.forEach((item)=>{
    if(item.value){
      if(queryString){
        queryString=queryString+`&${item.key}=${item.value}`
      }else{
        queryString=`${item.key}=${item.value}`
      }
    }
  })
  
  if(queryString){
    resource=`${resource}?${queryString}`;
    resource = resource.replace ("filter=&", "");
}
    return fetch(resource, {
        method: GET,
        headers: {
            "Content-Type": "application/json",
            "userauth": `Bearer ${token}`
        },
    })
        .then(statusParsing)
        .then(jsonParsing);
      
};
